import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators,ReactiveFormsModule } from '@angular/forms';
import { Constants } from '../shared/constants';
import { ForgotPassword } from '../shared/models/forgotpassword.model';
import { BaseHttpService } from '../shared/services/basehttp.service';
import forge from 'node-forge';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../shared/services/notifications.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
,  standalone: false
})

 export class ForgotPasswordComponent implements OnInit {
  public forgotPasswordForm: FormGroup
  public successMessage: string;
  public errorMessage: string;
  public showSuccess: boolean;
  public showError: boolean;
  public forgotpasswordscreeen:boolean=false;
  constant: Constants = new Constants();
  constructor(private _authService: BaseHttpService,private router: Router,private spinnerService: NgxSpinnerService,
    private notificationService: NotificationService,) { }

   ngOnInit(): void {
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl("", [Validators.required])
    })
 }

  public validateControl = (controlName: string) => {
    return this.forgotPasswordForm.controls[controlName].invalid && this.forgotPasswordForm.controls[controlName].touched
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.forgotPasswordForm.controls[controlName].hasError(errorName)
  }

  public forgotPassword = (forgotPasswordFormValue) => {
    this.spinnerService.show();
    this.showError = this.showSuccess = false;
    let rsa = forge.pki.publicKeyFromPem(this.constant.publicKey);
    // forgotPasswordFormValue.email = window.btoa(rsa.encrypt(forgotPasswordFormValue.email));
    forgotPasswordFormValue.email = window.btoa(rsa.encrypt(forgotPasswordFormValue.email, 'RSA-OAEP', {
      md: forge.md.sha1.create()
    }));
    const forgotPass = { ...forgotPasswordFormValue };
    const forgotPassDto: ForgotPassword = {
      email: forgotPass.email,
      clientURI: window.location.origin + this.constant.resetURL,
      password:""
    }

    this._authService.post(this.constant.forgotPassword, forgotPassDto)
    .subscribe(_ => {
      this.showSuccess = true;
      this.spinnerService.hide();
      this.router.navigate(['/', 'home'])
      this.notificationService.showSuccess("Please check your email to reset your password.","Link has been sent");
    },
    err => {
      this.showError = true;
      this.errorMessage = err.error;
      this.spinnerService.hide();
    }
    )
  }

  cancel(){
    this.router.navigate(['/', 'login'])
  }

}




